import script from "./ResumeOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResumeOverview.vue?vue&type=script&setup=true&lang=ts"

import "./ResumeOverview.vue?vue&type=style&index=0&id=13198eb9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13198eb9"]])

export default __exports__